







import { Component, Mixins } from "vue-property-decorator";
import { Size } from "../../../../domain/drawing";
import { PropertyEditableMixin, NewObjectStampableMixin } from "./mixins";
import StampableLocatorMenu from "./StampableLocatorMenu.vue";
import SingleLinePropertyEditor from "./SingleLinePropertyEditor.vue";

@Component({
  components: {
    stampableLocatorMenu: StampableLocatorMenu,
    propertyEditor: SingleLinePropertyEditor,
  },
})
export default class NewCrossPropertyEditor extends Mixins(PropertyEditableMixin, NewObjectStampableMixin) {
  async created(): Promise<void> {
    this.stampSize = this.$configuration.behavior.document.editor.newObjects.NewCross.locator.shouldStamp
      ? new Size(20, 20)
      : null;
    this.editingSource = await this.createSource();
  }
}
